import { ReactNode } from 'react';

interface PrimaryButtonProps {
  children: ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit';
  className?: string;
  disabled?: boolean;
}

export function PrimaryButton({
  children,
  onClick,
  type = 'button',
  className = '',
  disabled = false,
}: PrimaryButtonProps) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      aria-disabled={disabled}
      className={`h-[50px] px-8 bg-[#8e2a2f] transition-colors rounded-[10px] flex items-center justify-center ${
        disabled
          ? 'opacity-60 cursor-not-allowed'
          : 'hover:bg-[#7a2428] cursor-pointer'
      } ${className}`}
    >
      <span className="font-['DM_Sans',sans-serif] font-bold leading-[21px] text-white text-[14px] tracking-[-0.1px] whitespace-nowrap" style={{ fontVariationSettings: "'opsz' 14" }}>
        {children}
      </span>
    </button>
  );
}
